const  METHOD_WINDOW_CLOSE = "window_close";
const  METHOD_WINDOW_RELOAD = "window_reload";
const  METHOD_GO_HISTORY = "go_history";
export default {
  METHOD_WINDOW_CLOSE,
  METHOD_WINDOW_RELOAD,
  METHOD_GO_HISTORY,
  alert(msg, thenMethod, catchMethod) {
    _alert(msg, thenMethod, catchMethod);
  },
  alertError(){
    _alert("网络异常，请稍后重试。");
  },
  alertAndWindowClose(msg) {
    _alert(msg, METHOD_WINDOW_CLOSE, METHOD_WINDOW_CLOSE);
  },
  alertAndWindowReload(msg) {
    _alert(msg, METHOD_WINDOW_RELOAD, METHOD_WINDOW_RELOAD);
  },
  alertAndGoHistory(msg) {
    _alert(msg, METHOD_GO_HISTORY, METHOD_GO_HISTORY);
  }
}

function _alert(msg, thenMethod, catchMethod){
  ELEMENT.MessageBox.alert(msg, "提示", {
    confirmButtonText: "确定"
  })
    .then(() => {
      doMethod(thenMethod);
    })
    .catch(() => {
      doMethod(catchMethod);
    });
}

function doMethod(method){
  if (method === METHOD_WINDOW_CLOSE) {
    window.close();
  } else if (method === METHOD_WINDOW_RELOAD) {
    window.location.reload();
  } else if (method === METHOD_GO_HISTORY) {
    window.history.go(-1);
  }
}



// WEBPACK FOOTER //
// ./src/utils/global.js